module.exports = __webpack_public_path__ + "static/img/4.445b971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/4.png
// module id = kLZI
// module chunks = 1